import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static values = {travellerurl: String};

  traveller_flag(event){
    const el = event.currentTarget;
    Rails.ajax({
      url: this.travellerurlValue+"&traveller_flag="+el.checked,
      type: "GET",
      dataType: 'json',
      success: (response)=> {
        alert("更新しました");
      }
    });
  }
  
}
